import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "../Styles/Audios.css";
import "../Styles/Login.css";
import { LogInModel } from "./LoginModel";
import HeaderPage from "../App/HeaderPage";
import FooterPage from "../App/FooterPage";

const NewLoginPage: React.FC = () => {
  const [opens] = useState<boolean>(true);
  const cancelClickedRef = useRef<boolean>(false);
  const mountedRef = useRef<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  // capture redirect target from query or location state and persist it until login
  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      let redirect = params.get("redirect") || undefined;
      // also check location.state for redirect info
      if (!redirect && (location as any).state) {
        const st = (location as any).state as any;
        redirect = st?.redirect || st?.from || st?.to || undefined;
      }
      if (redirect) {
        // normalize
        if (!redirect.startsWith("/")) redirect = "/" + redirect;
        sessionStorage.setItem("postLoginRedirect", redirect);
      }
    } catch (err) {
      // ignore malformed URLSearchParams
    }
  }, [location]);

  // Keep the modal visible on this page unless user explicitly clicks the Cancel button
  // We cannot change LoginModel, so we intercept clicks on the Cancel button via a
  // capturing native listener to mark that the Cancel button was clicked before
  // LoginModel's onClose runs.
  useEffect(() => {
    mountedRef.current = true;

    function onCaptureClick(e: MouseEvent) {
      try {
        const target = e.target as HTMLElement | null;
        if (!target) return;
        // Find if the click occurred on the Cancel button inside the login modal
        const footerBtn = target.closest('.loginpag .modal-footer button, .loginpag .modal-footer .btn');
        if (footerBtn) {
          // Mark that cancel was clicked; LoginModel's onClose will run after this
          cancelClickedRef.current = true;
          // reset shortly after to avoid affecting other events
          setTimeout(() => (cancelClickedRef.current = false), 200);
        }
      } catch (err) {
        // ignore
      }
    }

    document.addEventListener('click', onCaptureClick, true); // capture phase
    return () => {
      mountedRef.current = false;
      document.removeEventListener('click', onCaptureClick, true);
    };
  }, []);

  const handleClose = () => {
    // This handler will be passed to LoginModel as onCloses. LoginModel calls this
    // for both backdrop/ESC and Cancel button clicks. We only want to redirect when
    // the Cancel button was clicked. Otherwise keep the modal open.
    if (cancelClickedRef.current) {
      // redirect to home page
      navigate('/');
    } else {
      // ignore backdrop/esc hide attempts (keep modal visible)
      // do nothing
    }
  };

  const handleLoginStateChange = (newState: boolean) => {
    // optional: after successful login you may want to navigate or reload
    if (newState) {
      const dest = sessionStorage.getItem("postLoginRedirect") || "/";
      sessionStorage.removeItem("postLoginRedirect");
      navigate(dest);
    }
  };

  return (
    <div>
      <HeaderPage />
      <div className="text-center gst-homebg-image" style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {/* Page intentionally minimal — render login modal centered */}
        <div style={{ width: "100%", maxWidth: 720 }}>
          <LogInModel opens={opens} onCloses={handleClose} onLoginStateChange={handleLoginStateChange} />
        </div>
      </div>
      <FooterPage />
    </div>
  );
};

export default NewLoginPage;